<template>
    <div>
        <div>
            <!-- 面包屑导航 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>管理</el-breadcrumb-item>
                <!-- :to="{ path: '/' }" -->
                <el-breadcrumb-item>队伍管理</el-breadcrumb-item>

            </el-breadcrumb>
        </div>
        
        <span
            style=" width:50%;margin: 8px;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
            队伍取号金额上限：{{ tableData.moneyUpper }}
            <el-button size="mini" type="danger" @click="updateTeamTo()">修改</el-button>
        </span>

        <span
            style=" width:50%;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
            每日首单重置次数上限：
            <span><el-input style="width: 200px;" v-model="tableData.resetsNumber"></el-input></span>
            <el-button size="mini" type="danger" @click="updateTeam()">修改</el-button>
            <span style="margin: 20px; color: red;">(设置为0无上限)</span>
        </span>

        <span
            style=" width:50%;margin: 8px;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
            最低取号金额：
            <span><el-input style="width: 200px;" v-model="tableData.moneyLower"></el-input></span>
            <el-button size="mini" type="danger" @click="updateTeam()">修改</el-button>
            <span style="margin: 20px; color: red;">(设置为0则无限制)</span>
        </span>

        <span
            style=" width:50%;margin: 8px;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
            首单优惠金额上限金额：
            <span><el-input style="width: 200px;" v-model="tableData.firstUpper"></el-input></span>
            <el-button size="mini" type="danger" @click="updateTeam()">修改</el-button>
            <span style="margin: 20px; color: red;">(设置为0则无限制)</span>
        </span>

        <span
            style=" width:50%;margin: 8px;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
            首单优惠金额上限超过上限，强制优惠金额：
            <span><el-input style="width: 200px;" v-model="tableData.firstMust"></el-input></span>
            <el-button size="mini" type="danger" @click="updateTeam()">修改</el-button>
            <span style="margin: 20px; color: red;">(设置为0则无限制)</span>
        </span>



        <el-dialog title=" 手续费设置" :visible.sync="dialogFormVisible" center>
            <h1 style="width: 100%;display: inline-block;text-align: center;">金额上限设置<span
                    style="color: red;">(整数)</span></h1>
            <div style="margin-bottom: 10px;text-align: center;">
                <el-input style="width:50%;" v-model="updateData.moneyUpper" placeholder="输入金额上限设置"></el-input>
            </div>
            <!-- v-model="upTeamFeeInfo.totalFee" -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateTeamFWF()">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import { getTeamLimitInfo, deleteTeamLimit, addTeamLimit, updateTeamLimit } from '../../../api/manage/teamlimit.js';

export default {
    data() {
        return {
            totalnum: 0,
            page: 1,
            size: 10,
            tableDataLoading: false,
            dialogFormVisible: false,
            tableData: {},
            updateData: {},
            updateForm: {

            },

        }
    },
    components: {

    },

    created() {
        this.dataSelect();
        // this.getdata(1)
    },



    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

        updateTeamTo() {
            this.updateData = JSON.parse(JSON.stringify(this.tableData));
            this.dialogFormVisible = true
        },

        updateTeamFWF() {
            let post = this.updateData;
            updateTeamLimit(post).then((res) => {
                this.dialogFormVisible = false;
                this.$message({
                    type: "success",
                    message: res.msg,
                    duration: 1500,
                    onClose: () => {
                        this.dataSelect()
                    }
                });
            })
        },

        updateTeam() {
            let post = this.tableData;
            updateTeamLimit(post).then((res) => {
                this.$message({
                    type: "success",
                    message: res.msg,
                    duration: 1500,
                    onClose: () => {
                        this.dataSelect()
                    }
                });
            })
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        dataSelect() {
            let post = {
                page: (this.page - 1) * this.size,
                size: this.size,
            }
            getTeamLimitInfo(post).then((res) => {
                if (res.code == 200) {
                    this.tableData = res.data.data
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })
        },

        // 添加分类弹框
        openDialogFormVisible(row) {
            this.updateForm = JSON.parse(JSON.stringify(row));
            this.dialogFormVisible = true
        },

    }
}
</script>

<style scoped>
.userRole {
    width: 100%;
}

/* 使用更具体的选择器以确保优先级 */
.el-input__inner {
    background-color: transparent !important;
    /* 设置为透明或其他颜色 */
}

.no-background ::v-deep .el-input__inner {
    background-color: transparent !important;
    /* 设置为透明或其他颜色 */
}

/* 对于 Vue 3 或较新的预处理器版本 */
.no-background :deep(.el-input__inner) {
    background-color: transparent !important;
    /* 设置为透明或其他颜色 */
}
</style>


// WEBPACK FOOTER //
// src/views/manage/teamlimit/index.vue